// extracted by mini-css-extract-plugin
export default {"baseButton":"styles_baseButton__79GoZ","baseIcon":"styles_baseIcon__fHck2"};